export default [
	{
		path: '/invitations/:token',
		lazy: async () => {
			const Module = await import('../../pages/services/account/InvitationLandingPage');
			return { Component: Module.default };
		},
	},
];
